import React, { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { SettingUpProjectPlanIntermediateScreen } from 'components/organisms/templates/projects/spaces/setting-up';
import { TemplateId } from 'data/templates/api';
import {
  useHasSetupSpacesInTemplate,
  useProjectTemplateSpaces,
} from 'data/templates/projects';

export const ProjectTemplateSpacesRedirect: FC<{
  templateId: TemplateId;
}> = ({ templateId }) => {
  const projectTemplateSpace = useProjectTemplateSpaces();
  const firstSpaceId = Object.keys(useProjectTemplateSpaces())[0];
  const spaceSetupState = useHasSetupSpacesInTemplate();

  if (spaceSetupState === 'IN_PROGRESS' || spaceSetupState === 'YET_TO_START') {
    return <SettingUpProjectPlanIntermediateScreen />;
  }
  if (!firstSpaceId) {
    return <Redirect to="/templates" />;
  }

  const firstSpaceTabId =
    projectTemplateSpace[firstSpaceId].spaceTabs[0]?.spaceTabId || 'new';

  return (
    <Redirect
      to={`/templates/projects/${templateId}/spaces/${firstSpaceId}/tabs/${firstSpaceTabId}`}
    />
  );
};
